import { useState } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import { authService } from "../../services/api";
import "./Login.css";

function RestablecerPassword() {
  const [searchParams] = useSearchParams();
  const token = searchParams.get("token") || "";
  const [password, setPassword] = useState("");
  const [confirmarPassword, setConfirmarPassword] = useState("");
  const [error, setError] = useState("");
  const [cargando, setCargando] = useState(false);
  const [exito, setExito] = useState(false);
  const navigate = useNavigate();

  const manejarSubmit = async (e) => {
    e.preventDefault();
    setError("");

    if (password.length < 6) {
      setError("La contraseña tiene que tener al menos 6 caracteres");
      return;
    }

    if (password !== confirmarPassword) {
      setError("Las contraseñas no coinciden");
      return;
    }

    setCargando(true);
    try {
      await authService.resetearPassword(token, password);
      setExito(true);
    } catch (error) {
      setError(
        error.response?.data ||
          "El link es inválido o venció. Pedí uno nuevo desde la pantalla de login."
      );
    } finally {
      setCargando(false);
    }
  };

  return (
    <div className="login-pagina">
      <div className="login-fondo">
        <div className="login-circulo login-circulo-1"></div>
        <div className="login-circulo login-circulo-2"></div>
      </div>
      <div className="login-contenedor">
        <div className="login-logo" onClick={() => navigate("/")}>
          <span className="login-logo-principal">Glowroom</span>
          <span className="login-logo-secundario">MVD</span>
        </div>
        <div className="login-card">
          {!token ? (
            <div className="login-bienvenida">
              <span className="bienvenida-icono">⚠</span>
              <h2 className="bienvenida-titulo">Link inválido</h2>
              <p className="bienvenida-texto">
                Este link no es válido. Pedí uno nuevo desde la pantalla de login.
              </p>
              <button className="btn-principal login-btn" onClick={() => navigate("/login")}>
                Ir al login
              </button>
            </div>
          ) : exito ? (
            <div className="login-bienvenida">
              <span className="bienvenida-icono">✦</span>
              <h2 className="bienvenida-titulo">Contraseña actualizada</h2>
              <p className="bienvenida-texto">
                Ya podés iniciar sesión con tu nueva contraseña.
              </p>
              <button className="btn-principal login-btn" onClick={() => navigate("/login")}>
                Iniciar sesión
              </button>
            </div>
          ) : (
            <>
              <h2 className="bienvenida-titulo" style={{ marginBottom: 8 }}>
                Elegí tu nueva contraseña
              </h2>

              {error && (
                <div className="login-error">
                  <span>⚠</span> {error}
                </div>
              )}

              <form className="login-formulario" onSubmit={manejarSubmit}>
                <div className="formulario-grupo">
                  <label className="formulario-label">Nueva contraseña</label>
                  <input
                    type="password"
                    value={password}
                    onChange={(e) => setPassword(e.target.value)}
                    className="formulario-input"
                    placeholder="••••••••"
                    required
                  />
                </div>
                <div className="formulario-grupo">
                  <label className="formulario-label">Confirmar contraseña</label>
                  <input
                    type="password"
                    value={confirmarPassword}
                    onChange={(e) => setConfirmarPassword(e.target.value)}
                    className="formulario-input"
                    placeholder="••••••••"
                    required
                  />
                </div>
                <button type="submit" className="btn-principal login-btn" disabled={cargando}>
                  {cargando ? "Guardando..." : "Guardar contraseña"}
                </button>
              </form>
            </>
          )}
        </div>
      </div>
    </div>
  );
}

export default RestablecerPassword;
